// import {

import {
  GET_FEED_USER_STAT,
  GET_FEED_USER_STAT_SUCCESS,
  GET_SHOP_MERCHANT_STAT,
  GET_SHOP_MERCHANT_STAT_SUCCESS,
  GET_SHOP_USER_STAT,
  GET_SHOP_USER_STAT_SUCCESS,
  GET_STORY_USER_STAT,
  GET_STORY_USER_STAT_SUCCESS,
} from "../../actions/analytics/types";

//     GET_SHOP_STATISTICS,
//     GET_SHOP_STATISTICS_SUCCESS,
//   } from "../../actions/statistics/types";

const initialState = {
  shopUserStat: {},
  shopUserStatLoading: false,
  shopMerchantStat: {},
  shopMerchantStatLoading: false,
  feedUserStat: {},
  feedUserStatLoading: false,
  storyUserStat: {},
  storyUserStatLoading: false,
};

export const analytics = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SHOP_USER_STAT:
      return {
        ...state,
        shopUserStatLoading: true,
      };
    case GET_SHOP_USER_STAT_SUCCESS:
      return {
        ...state,
        shopUserStatLoading: false,
        shopUserStat: payload,
      };
    case GET_SHOP_MERCHANT_STAT:
      return {
        ...state,
        shopMerchantStatLoading: true,
      };
    case GET_SHOP_MERCHANT_STAT_SUCCESS:
      return {
        ...state,
        shopMerchantStatLoading: false,
        shopMerchantStat: payload,
      };
    case GET_FEED_USER_STAT:
      return {
        ...state,
        feedUserStatLoading: true,
      };
    case GET_FEED_USER_STAT_SUCCESS:
      return {
        ...state,
        feedUserStatLoading: false,
        feedUserStat: payload,
      };

      

      case GET_STORY_USER_STAT:
        return {
          ...state,
          storyUserStatLoading: true,
        };
    case GET_STORY_USER_STAT_SUCCESS:
        return {
          ...state,
          storyUserStatLoading: false,
          storyUserStat: payload,
        };

    default: {
      return state;
    }
  }
};
